import { actionType } from "..";
import {
    CREATE_CONVERSATION, DELETE_ALL_MESSAGES, DELETE_CONVERSATION,
    DELETE_MESSAGES_BY_ID, DELETE_PARTICIPANTS,
    DELETE_UNREAD_MSG_COUNT,
    SELECTED_CONVERSATION, UPDATE_CONVERSATIONS,
    UPDATE_CUSTOMERDETAILS,
    UPDATE_INITIAL_STATE,
    UPDATE_MESSAGES_BY_ID, UPDATE_PAGE, UPDATE_PARTICIPANTS, UPDATE_UNREAD_MSG_COUNT
} from "../action-types/conversationActionTypes";

let initialState = {
    allConversations: [],
    messagesById: {},
    participants: {},
    customer:{},
    unreadMsgCount: {},
    selectedConversation: null,
    page: 0,
    limit: 25,
}

const conversationReducer = (state = initialState, action: actionType) => {
    switch (action.type) {
        case UPDATE_CONVERSATIONS:
        case DELETE_CONVERSATION:
        case CREATE_CONVERSATION:
            return {
                ...state,
                allConversations: [...action.payload]
            }
        case UPDATE_MESSAGES_BY_ID:
            return {
                ...state,
                messagesById: { ...state.messagesById, ...action.payload }
            }
        case SELECTED_CONVERSATION:
            return {
                ...state,
                selectedConversation: { ...action.payload }
            }
        case UPDATE_PARTICIPANTS:
            return {
                ...state,
                participants: { ...state.participants, ...action.payload }
            }
        case UPDATE_CUSTOMERDETAILS:
            return {
                ...state,
                customer: { ...action.payload }
            }

        case UPDATE_UNREAD_MSG_COUNT:
            return {
                ...state,
                unreadMsgCount: { ...state.unreadMsgCount, ...action.payload }
            }

        case DELETE_MESSAGES_BY_ID:
            return {
                ...state,
                messagesById: { ...action.payload }
            }
        case DELETE_PARTICIPANTS:
            return {
                ...state,
                participants: { ...action.payload }
            }
        case DELETE_UNREAD_MSG_COUNT:
            return {
                ...state,
                unreadMsgCount: { ...action.payload }
            }
        case DELETE_ALL_MESSAGES: {
            return {
                ...state,
                messagesById: {}
            }
        }
        case UPDATE_INITIAL_STATE: {
            return {
                ...initialState
            }
        }
        case UPDATE_PAGE: {
            return {
                ...state,
                page: action.payload
            }
        }

        default:
            return state;
    }
}


export default conversationReducer;